import moment from 'moment'
import { Poppins } from 'next/font/google'
import React, { useState } from 'react'
import EnrollForm from './enroll-form'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})

export default function TrainingMode({SectionRef,title,location,location1}) {

const [selectedBatch,setSelectedBatch] = useState(false);


// Regular Batch
 
const getRegularBatch = () => {
    const today = moment();
    const daysUntilMonday = (7 - today.day() + 1) % 7; // Calculate days until next Monday
    return today.add(daysUntilMonday, 'days');
  };

  // Get the next Monday's date and month
const nextMonday = getRegularBatch();
const nextMondayDate = nextMonday.format('DD');
const nextMondayMonth = nextMonday.format('MMM');

//   Week END bATCH

const getWeekEndBatch = () => {
    const today = moment();
    const daysUntilSaturday = (6 - today.day() ) % 7; // Calculate days until next Saturday
    return today.add(daysUntilSaturday, 'days');
  };
 
  // Get the next Saturday's date and month
  const nextSaturday = getWeekEndBatch();
  const nextSaturdayDate = nextSaturday.format('DD');
  const nextSaturdayMonth = nextSaturday.format('MMM');


const batch = [
    {   
        batch:"Week-Days Batch",
        day:`Start From ${nextMondayDate} ${nextMondayMonth}`,
        time:"11:00 AM TO 12:00 PM IST",
        gmt:"(GMT +5:30)"
    },
    {
        batch:"Week-End Batch",
        day:`Start From ${nextSaturdayDate} ${nextSaturdayMonth}`,
        time:"09:00 AM TO 11:00 AM IST",
        gmt:"(GMT +5:30)"
    },
    {
        batch:"Online Clasess",
        day:`Week Days & Week End`,
        time:"Flexible Timings Available",
        gmt:"(GMT +5:30)"
    },
    ,
    {
        batch:"Corporate Training",
        day:`Week Days & Week End`,
        time:"Flexible Timings Available",
        gmt:"(GMT +5:30)"
    },
]

const handleBatchClick = (batch) =>{
    setSelectedBatch(batch)
} 

// const Location = typeof location1 == "string" && location1.trim() ? location1.split(" ").pop() : "your location";

  return (
   <>
   <section className='whole-pdtb' ref={SectionRef}>
    <div className='container'>
   <h2 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}>
      Available {title} Training  <span className={`ylw-clr fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}>  {location ? `Options in  ${location}` : ''} </span> </h2>
   <div className={`df  mfjc gap11 fw mt32 tmt28 mmt24`}>
    {batch.map((items,index)=>{
        return(
    <div className={`training-card`} key={index}
    > 
        <h3 className='fs-20 mfs-16 fwb500 mfwb600'>{items.batch}</h3>
        <p className={`fs-16 mfs-15 mt8  fwb500 ${popins.className}`}>{items.day}</p>
     <p className={`fs-16 mfs-15 fwb500 ${popins.className}`}>{items.time}</p>
     <p className={`fs-16 mfs-15 fwb500 ${popins.className}`}>{items.gmt}</p>
   
   <button className={`fs-16 mfs-15 fwb600 pdtb10 mt20 training-btn ${popins.className}`}
    onClick={() => handleBatchClick(items)}>Enroll Now</button>
    </div>
    )})}
   </div>
   </div>
   </section>
   {selectedBatch && (
    <><div className="backdrop"></div><div className="popup">
                  <EnrollForm
                     course={`${title}${location1 ? ' ' + location1 : ''}`}
                     batch={selectedBatch.batch}
                      hideHeader={false}
                      closeBtn={true}
                      closeForm={() => setSelectedBatch(null)} />
              </div></>

   )}
   </>
)
}
